/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { ResponsiveBar } from "@nivo/bar";
import moment from "moment";

const Bar = ({ statics }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Ekran boyutunu takip eden hook
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Grafik Teması (Karanlık Tema & Dinamik Yazı Boyutu)
  const theme = {
    axis: {
      domain: { line: { stroke: "rgba(255,255,255,0.1)" } },
      legend: {
        text: {
          fontSize: isMobile ? 10 : 13,
          fontWeight: 600,
          fill: "#fff",
          opacity: isMobile ? 0.7 : 1,
        },
      },
      ticks: {
        line: { stroke: "rgba(255,255,255,0.2)", strokeWidth: 1 },
        text: {
          fill: "rgba(255,255,255,0.5)",
          fontSize: isMobile ? 9 : 11,
        },
      },
    },
    grid: {
      line: { stroke: "rgba(255,255,255,0.05)", strokeWidth: 1 },
    },
    tooltip: {
      container: {
        background: "#1A1A2E",
        color: "#fff",
        fontSize: 12,
        borderRadius: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
        border: "1px solid rgba(255,255,255,0.1)",
      },
    },
  };

  return (
    <ResponsiveBar
      data={statics}
      keys={["Kredi_Karti", "Havale"]}
      indexBy="name"
      // Mobilde sağ boşluğu kapatıp alt boşluğu artırıyoruz
      margin={{
        top: 30,
        right: isMobile ? 20 : 130,
        bottom: isMobile ? 90 : 60,
        left: isMobile ? 45 : 70,
      }}
      padding={isMobile ? 0.5 : 0.4}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      // Renk ve Degrade Tanımları
      colors={({ id }) => (id === "Kredi_Karti" ? "#22D3EE" : "#818CF8")}
      defs={[
        {
          id: "gradientCyan",
          type: "linearGradient",
          colors: [
            { offset: 0, color: "#22D3EE" },
            { offset: 100, color: "#0891B2" },
          ],
        },
        {
          id: "gradientIndigo",
          type: "linearGradient",
          colors: [
            { offset: 0, color: "#818CF8" },
            { offset: 100, color: "#4F46E5" },
          ],
        },
      ]}
      fill={[
        { match: { id: "Kredi_Karti" }, id: "gradientCyan" },
        { match: { id: "Havale" }, id: "gradientIndigo" },
      ]}
      borderRadius={4}
      borderWidth={1}
      borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
      theme={theme}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 10,
        // Mobilde ay isimlerini çapraz yaparak sığdırıyoruz
        tickRotation: isMobile ? -45 : 0,
        legend: isMobile ? "" : "AYLAR",
        legendPosition: "middle",
        legendOffset: 45,
      }}
      axisLeft={{
        tickSize: 0,
        tickPadding: 10,
        tickRotation: 0,
        // Mobilde soldaki uzun yazıyı kısaltıyoruz
        legend: isMobile ? "SATIŞ" : `${moment().format("YYYY")} SATIŞ ANALİZİ`,
        legendPosition: "middle",
        legendOffset: isMobile ? -35 : -55,
      }}
      enableLabel={false}
      legends={[
        {
          dataFrom: "keys",
          // Mobilde göstergeyi alta alıyoruz
          anchor: isMobile ? "bottom" : "bottom-right",
          direction: isMobile ? "row" : "column",
          justify: false,
          translateX: isMobile ? 0 : 120,
          translateY: isMobile ? 80 : 0,
          itemsSpacing: isMobile ? 10 : 8,
          itemWidth: isMobile ? 100 : 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          itemTextColor: "#fff",
          symbolSize: 12,
          symbolShape: "circle",
          effects: [{ on: "hover", style: { itemOpacity: 1 } }],
        },
      ]}
      animate={true}
      motionConfig="stiff"
    />
  );
};

export default Bar;
